<template>
  <div>
    <!-- no-close-on-backdrop
      no-close-on-esc -->
    <b-modal
      ref="modal-settings-type"
      :title="$t(titleModal)"
      modal-class="modal-primary"
      @hidden="$emit('hideModal')"
      scrollable
      size="sm"
      no-close-on-backdrop
    >
      <ValidationObserver ref="form-validation">
        <b-row>
          <!-- Type Name -->
          <b-col cols="12">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|max:100"
              name="name"
            >
              <b-form-group
                :label="$t('Vehicle type')"
                :state="errors[0] ? false : null"
              >
                <b-form-input
                  type="text"
                  v-model="form.name"
                  :class="{ 'border-danger': errors[0] }"
                ></b-form-input>
                <span v-if="errors[0]" class="text-danger">
                  {{ $t("Brand") }} {{ errors[0] }}
                </span>
              </b-form-group>
            </ValidationProvider>
          </b-col>

        </b-row>
      </ValidationObserver>
      <template #modal-footer>
        <b-container fluid>
          <b-row>
            <b-col class="d-flex align-items-center justify-content-end p-0">
              <b-button
                class="mr-1"
                variant="outline-danger"
                @click="$emit('hideModal', false)"
                v-t="'CANCEL'"
              >
              </b-button>
              <b-button
                v-if="form.id == null"
                :disabled="form.models == 0 && form.id == null"
                variant="outline-primary"
                @click="save"
              >
                {{ $t(titleButton) }}
              </b-button>

              <b-button
              v-if="form.id != null"
                :disabled="form.models == 0 && form.id != null"
                variant="outline-warning"
                @click="edit"
              >
                {{ $t(titleButton) }}
              </b-button>
            </b-col>
          </b-row>
        </b-container>
      </template>
    </b-modal>
  </div>
</template>

<script>
/* Service */
import VehicleService from "@/views/commons/vehicles/services/vehicle.service.js";
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      form: {
        id: null,
        name: null,
      },
    };
  },
  props: {
    vehicleTypeId: {
      type: Number,
      default: null,
    },
  },
  mounted() {
    this.toggleModal("modal-settings-type");
  },
  async created() {
    try {
      this.addPreloader();
      this.form.id = this.vehicleTypeId;
      await Promise.all([this.getDataVehicleTypeById()]);
    } catch (error) {
      console.log(error);
      this.showToastError("Proceso fallido", "Error");
    } finally {
      this.removePreloader();
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
    titleModal() {
      return this.brandID == null ? "NEW VEHICLE TYPE" : "EDIT VEHICLE TYPE";
    },
    titleButton() {
      return this.brandID == null ? "SAVE" : "UPDATE";
    },
  },
  methods: {
    async getDataVehicleTypeById() {
      if (this.form.id == null) return;
      try {
        const { data } = await VehicleService.getDataVehicleTypeById({
          vehicle_type_id: this.vehicleTypeId,
        });
        this.form.name = data.name;
      } catch (error) {
        throw error;
      }
    },

    async save() {
      const validate = await this.$refs["form-validation"].validate();
      if (!validate) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();

        const params = {
          vehicle_type_id: this.vehicleTypeId,
          name: this.form.name,
          user_id: this.currentUser.id,
        };

        const { data } = await VehicleService.saveVehicleType(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error?.response?.data);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

    async edit() {
      const validate = await this.$refs["form-validation"].validate();
      if (!validate) return;

      const confirm = await this.showConfirmSwal();
      if (!confirm.isConfirmed) return;
      try {
        this.addPreloader();

        const params = {
          vehicle_type_id: this.form.id,
          name: this.form.name,
          user_id: this.currentUser.id,
        };

        const { data } = await VehicleService.editVehicleType(params);
        if (data.type == "warning") {
          this.showToastWarning(data.message);
          return;
        }
        if (data.type == "success") this.showToastSuccess(data.message);
        this.$emit("registered");
      } catch (error) {
        console.log(error);
        this.showToastError(error?.response?.data?.message);
      } finally {
        this.removePreloader();
      }
    },

  },
};
</script>

<style lang="scss">
</style>